<form [formGroup]="loginForm" (submit)="login()">
    <div *ngIf="loginError" class="form-row mb-2">
        <div class="col-12">
            <alert type="danger" [dismissible]="dismissible" (onClosed)="onClosed(alert)">{{ alert
                }}</alert>
        </div>
    </div>
    <div class="form-row mb-2">
        <div class="col-12">
            <input #userNameInput id="username" [(ngModel)]="inputs.userName" autocomplete="off"
                formControlName="username" type="text" class="form-control" [attr.inputmode]="getInputMode" [placeholder]="this.placeholderUsername"
                [ngClass]="{ 'is-invalid': controls.username.errors && controls.username.touched, 'new-input':  enableCustomKeyboard}"
                data-cy-input="username" (focus)="scroll(target)" (onChange)="scroll(target)" (focus)="onInputFocus($event)"
                (change)="onInputChange($event)">
            <div *ngIf="loginForm.invalid" class="invalid-feedback">
                <div *ngIf="controls.username.hasError('required') && controls.username.touched">Username
                    is required</div>
            </div>
        </div>
    </div>
    <div class="input-group">
        <input #passwordInput id="password" [(ngModel)]="inputs.password" [attr.inputmode]="getInputMode" formControlName="password"
            type="{{ inputtype }}" class="form-control" [placeholder]="this.placeholderPassword" data-cy-input="password"
            [ngClass]="{ 'is-invalid': controls.password.errors && controls.password.touched, 'new-input':  enableCustomKeyboard }"
            (focus)="onInputFocus($event)" (change)="onInputChange($event)" />

        <span class="input-group-append">
            <button class="btn btn-outline-primary show-password" [ngClass]="{ 'active' : inputtype === 'text'}"
                (click)="showPassword($event)">
                <mat-icon svgIcon="view"></mat-icon>
            </button>
        </span>
    </div>
    <div class="invalid-feedback d-flex mb-4">
        <span *ngIf="controls.password.hasError('required') && controls.password.touched">Password
            is required</span>
    </div>
    <div class="form-row mb-4">
        <div class="form-group col-12">
            <button #target class="btn btn-primary btn-block" type="submit" [disabled]="!loginForm.valid"
                data-cy-button="signin">SIGN
                IN</button>
            <button *ngIf="isTrainingRequestsEnabled" type="button" class="btn btn-link-outline btn-block" (click)="loginAndNavigateToRequestTraining()">
                REQUEST TRAINING
            </button>
        </div>
    </div>
</form>

<div class="keyboard-container" *ngIf="enableCustomKeyboard">
	<app-custom-keyboard #usernameKeyboard [template]="keyboardTemplate" [setValue]="this.controls.username.value"
		[hidden]="!showUsernameKeyboard" (typedValue)="usernameKeyboardInput($event)"></app-custom-keyboard>
	<app-custom-keyboard #passwordKeyboard [template]="keyboardTemplate" [hidden]="!showPasswordKeyboard" [setValue]="this.controls.password.value"
		(typedValue)="passwordKeyboardInput($event)"></app-custom-keyboard>
</div>